import axiosClient from 'config/axios';
import tokenConfig from 'config/auth';
import socket from 'config/socket';

import {
  GET_EXPENSES, ADD_EXPENSE/*, DELETE_EXPENSE*/
} from 'redux/actionTypes';
import { incrementIDGen } from '.';
import { expense } from 'variables/idGenType';
import { standard } from 'variables/userAccountTypes';

export const getExpenses = () => (dispatch, getState) => {
  axiosClient
    .get('/api/expenses', tokenConfig(getState))
    .then(res => {
      dispatch({
        type: GET_EXPENSES,
        payload: res.data
      });
    })
    .catch(err => console.log(err))
};

export const getExpensesAdmin = () => (dispatch, getState) => {
  axiosClient
    .get('/api/expenses/admin', tokenConfig(getState))
    .then(res => {
      dispatch({
        type: GET_EXPENSES,
        payload: res.data
      });
    })
    .catch(err => console.log(err))
};

export const addExpense = (newExpense, userId, adminId) => (dispatch, getState) => {
  axiosClient
    .post('/api/expenses', newExpense, tokenConfig(getState))
    .then(res => {
      dispatch(incrementIDGen({ id: userId, field: expense }));
      dispatch({
        type: ADD_EXPENSE,
        payload: res.data
      });
      //socket will only emit for standard users.
      if(getState().activeUserType === standard) {
        socket.emit('private-request', {
          request: 'add-expense',
          userId: adminId,
          data: res.data
        });
      }
    })
    .catch(err => console.log(err))
};

//IDGen is not incremented here because users can only create their own expenses.
export const addExpenseSocket = newExpense => ({
  type: ADD_EXPENSE,
  payload: newExpense
});

/*export const deleteExpense = (data) => (dispatch, getState) => {
  axiosClient
    .patch('/api/expenses/delete', data, tokenConfig(getState))
    .then(res => {
      dispatch({
        type: DELETE_EXPENSE,
        payload: data.id
      });
    })
    .catch(err => console.log(err))
};*/